import { UserPermissionsConstants, status } from '../Constants';

export function usersPermissionsReducer(state = {}, action: any) {
    switch (action.type) {
        case UserPermissionsConstants.USER_PERMISSIONS_REQUEST:
            return {
                ...state,
                user_permissions_status: status.IN_PROGRESS,
                userPermissionsList: action.data
            };
        case UserPermissionsConstants.USER_PERMISSIONS_SUCCESS:
            return {
                ...state,
                user_permissions_status: status.SUCCESS,
                userPermissionsList: action.data
            };
        case UserPermissionsConstants.USER_PERMISSIONS_FAILURE:
            return {
                ...state,
                user_permissions_status: status.FAILURE,
                userPermissionsList: null
            };
        default:
            return state;
    }
}
